import { render, staticRenderFns } from "./DevicesTableSkeletonMobileItem.vue?vue&type=template&id=dfb1ea72&scoped=true"
import script from "./DevicesTableSkeletonMobileItem.vue?vue&type=script&lang=js"
export * from "./DevicesTableSkeletonMobileItem.vue?vue&type=script&lang=js"
import style0 from "./DevicesTableSkeletonMobileItem.vue?vue&type=style&index=0&id=dfb1ea72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1ea72",
  null
  
)

export default component.exports